import { createContext, useContext, useEffect, useState } from "react";
import { doc, getDoc, collection, getDocs } from "firebase/firestore";
import { useFirebase } from "./FirebaseProvider";
import {
	PaymentsProviderType,
	PlansSettings,
} from "../types/providers/PaymentsProvider";

import { useAuth } from "./AuthenticationProvider";

const PaymentsContext = createContext<PaymentsProviderType>(
	{} as PaymentsProviderType
);

export const PaymentsProvider = ({
	children,
}: {
	children: any;
}): JSX.Element => {
	const { myFS } = useFirebase();
	const [plans, setPlans] = useState<PlansSettings[]>([]);
	const products = [
		{ priceId: "price_1P7JXKANVtnBUNBJ3gFChoXP", label: "Basic 24€ / M" },
		{ priceId: "price_1P7JXKANVtnBUNBJ3gFChoXP", label: "Basic 24€ / M" },
		{ priceId: "price_1P7JXKANVtnBUNBJ3gFChoXP", label: "Basic 24€ / M" },
		{ priceId: "price_1P7JXKANVtnBUNBJ3gFChoXP", label: "Basic 24€ / Y" },
		{ priceId: "price_1P7JXKANVtnBUNBJ3gFChoXP", label: "Basic 24€ / Y" },
		{ priceId: "price_1P7JXKANVtnBUNBJ3gFChoXP", label: "Basic 24€ / Y" },
	];
	const getPlans = async () => {
		try {
			const collectionRef = collection(myFS, "plans");
			const snap = await getDocs(collectionRef);

			let plans = [] as PlansSettings[];
			if (snap.empty) return;
			snap.docs.forEach((doc) => {
				const data = doc.data() as PlansSettings;
				plans.push({
					title: data.title,
					monthly: data.monthly,
					yearly: data.yearly,
					orderInList: data.orderInList,
				});
			});

			plans.sort((a, b) => a.orderInList - b.orderInList);
			if (plans.length !== 0) setPlans(plans);
		} catch (err) {
			console.error(err);
		}
	};

	const paymentsValues: PaymentsProviderType = { plans, getPlans };

	return (
		<PaymentsContext.Provider value={paymentsValues}>
			{children}
		</PaymentsContext.Provider>
	);
};

export const usePaymentsProvider = () => useContext(PaymentsContext);
